import axios from 'axios';

const service = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://www.ogolden.com/',
  timeout: 15000,
});

// 响应拦截器：统一错误处理（无JWT逻辑）
service.interceptors.response.use(
  response => response.data,
  error => {
    console.error('API请求失败:', error);
    return Promise.reject(error);
  }
);

export default service;
